import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'home',
    name: 'Home',
    meta: { title: '首页', showFooter: true },
    component: () => import('@/views/home/index.vue')
  },
  {
    path: 'home/apply-config',
    name: 'ApplyConfig',
    component: () => import('@/views/home/apply-config/index.vue')
  },
  {
    path: 'home/apply-config/record',
    name: 'ApplyConfigRecord',
    component: () => import('@/views/home/apply-config/record/index.vue')
  }
]

export default routes
